"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import Image from "next/image";
import { ThemeToggle } from "@/components/theme-toggle";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { usePathname } from "next/navigation";

export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  return (
    <nav className="border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center">
            <Image src="/logo.png" alt="Chain Fundamentals logo" width="50" height="50" className="pr-2"></Image>
            <Link href="/" className="text-xl font-bold">
              Chain Fundamentals
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-4">
            <Link href="/dashboard">
              <Button variant={pathname.startsWith("/dashboard") ? "default" : "ghost"} size="sm">
                Dashboard
              </Button>
            </Link>
            <Link href="/mcp">
              <Button variant={pathname.startsWith("/mcp") ? "default" : "ghost"} size="sm">
                MCP
              </Button>
            </Link>
            <Link href="/research">
              <Button variant={pathname.startsWith("/research") ? "default" : "ghost"} size="sm">
                Research
              </Button>
            </Link>
            <Link href="mailto:rajiv@chainfundamentals.io">
              <Button variant="ghost" size="sm">
                Contact
              </Button>
            </Link>
            <ThemeToggle />
          </div>

          {/* Mobile Menu Button */}
          <div className="flex md:hidden items-center gap-2">
            <ThemeToggle />
            <Button
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle menu"
            >
              {isOpen ? (
                <X className="h-5 w-5" />
              ) : (
                <Menu className="h-5 w-5" />
              )}
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden border-t border-border/40">
            <div className="flex flex-col py-4 space-y-2">
              <Link
                href="/dashboard"
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-md"
              >
                Dashboard
              </Link>
              <Link
                href="/mcp"
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-md"
              >
                MCP
              </Link>
              <Link
                href="/research"
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-md"
              >
                Research
              </Link>
              <Link
                href="mailto:rajiv@chainfundamentals.io"
                onClick={() => setIsOpen(false)}
                className="px-4 py-2 text-sm font-medium hover:bg-accent hover:text-accent-foreground rounded-md"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
